export type MarketConditionStatus = 'green' | 'yellow' | 'red';

export const marketConditionTone: Record<MarketConditionStatus, string> = {
  green: 'border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-700 dark:bg-emerald-950 dark:text-emerald-200',
  yellow: 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200',
  red: 'border-rose-300 bg-rose-50 text-rose-800 dark:border-rose-700 dark:bg-rose-950 dark:text-rose-200',
};

export const marketConditionDot: Record<MarketConditionStatus, string> = {
  green: 'bg-emerald-500',
  yellow: 'bg-amber-500',
  red: 'bg-rose-500',
};

export function marketStatusLabel(status?: MarketConditionStatus | null) {
  return status ? status[0].toUpperCase() + status.slice(1) : 'Not set';
}

/** Display fallback only. An empty saved note remains empty for editing. */
export function marketConditionNote(text?: string | null) {
  return text?.trim() || 'Normal Operations';
}
